var map = {
	"./bg.json": [
		971,
		0
	],
	"./cs.json": [
		972,
		1
	],
	"./da.json": [
		973,
		2
	],
	"./de.json": [
		974,
		3
	],
	"./el.json": [
		975,
		4
	],
	"./en.json": [
		976,
		5
	],
	"./es-AR.json": [
		977,
		6
	],
	"./es-ES.json": [
		978,
		7
	],
	"./fi.json": [
		979,
		8
	],
	"./fr.json": [
		980,
		9
	],
	"./hu.json": [
		981,
		10
	],
	"./it.json": [
		982,
		11
	],
	"./ja.json": [
		983,
		12
	],
	"./ko.json": [
		984,
		13
	],
	"./nb.json": [
		985,
		14
	],
	"./nl.json": [
		986,
		15
	],
	"./pl.json": [
		987,
		16
	],
	"./pt-BR.json": [
		988,
		17
	],
	"./pt-PT.json": [
		989,
		18
	],
	"./ro.json": [
		990,
		19
	],
	"./ru.json": [
		991,
		20
	],
	"./sl.json": [
		992,
		21
	],
	"./sv.json": [
		993,
		22
	],
	"./ta.json": [
		994,
		23
	],
	"./th.json": [
		995,
		24
	],
	"./tr.json": [
		996,
		25
	],
	"./zh-CN.json": [
		997,
		26
	],
	"./zh-TW.json": [
		998,
		27
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 963;
module.exports = webpackAsyncContext;